<template>
    <div class="main">
        <!--Filter-->
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 pt-2 pb-0 flex-row" outlined>
                <v-form ref="filtroValido" class="slim">
                    <v-container class="d-flex ml-2 pt-2 flex-row flex-wrap">
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTCodigo" label="Código" v-on:keyup.enter="loadData" clearable outlined dense></v-text-field>
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTNombre" label="Nombre" v-on:keyup.enter="loadData" clearable outlined dense></v-text-field>
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTDireccion" label="Dirección" v-on:keyup.enter="loadData" clearable outlined dense></v-text-field>
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTTelefono" label="Teléfono" v-on:keyup.enter="loadData" clearable outlined dense></v-text-field>
                        <v-autocomplete class="pr-2 mx-240" v-model="filter.fkNMunicipio" :items="municipalities" clearable item-text="fldTMunicipioEndonimo" item-value="idMunicipio" 
                                        label="Municipio" v-on:keyup.enter="loadData" outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-2 mx-240" v-model="filter.provincia" :items="provinces" item-text="fldTProvinciaExonimo" clearable item-value="idNProvincia" 
                                        label="Provincia" v-on:keyup.enter="loadData" outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-2 mx-240" v-model="filter.fkNGestor" :items="contacts" item-text="fldTNombre" clearable item-value="idNContacto" 
                                        label="Gestor de mantenimiento" v-on:keyup.enter="loadData" outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-1 mx-240" v-model="filter.fkNTecnico" :items="contacts" item-text="fldTNombre" clearable item-value="idNContacto" 
                                        label="Técnico" v-on:keyup.enter="loadData" outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-1 mx-240" v-model="filter.fkNJefeZona" :items="contacts" item-text="fldTNombre" clearable item-value="idNContacto" 
                                        label="Jefe de zona" v-on:keyup.enter="loadData" outlined dense></v-autocomplete>
                        <v-autocomplete class="pr-1 mx-240" v-model="filter.fkNEjecutivo" :items="contacts" item-text="fldTNombre" clearable item-value="idNContacto" 
                                        label="Ejecutivo" v-on:keyup.enter="loadData" outlined dense></v-autocomplete>
                        <v-menu v-model="menuFechaAperturaFilter" :close-on-content-click="false" :nudge-right="40" clearable transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field class="pr-2 mx-240" v-model="filter.fldDApertura" label="Fecha de apertura" prepend-icon="" outlined clearable dense readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="filter.fldDApertura" locale="es-es" :first-day-of-week="1" v-on:keyup.enter="loadData" @input="menuFechaAperturaFilter = false"></v-date-picker>
                        </v-menu>
                        <v-menu v-model="menuFechaCierreFilter" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field class="pr-2 mx-240" v-model="filter.fldDCierre" label="Fecha de cierre" prepend-icon="" outlined dense clearable readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="filter.fldDCierre" locale="es-es" :first-day-of-week="1" v-on:keyup.enter="loadData" @input="menuFechaCierreFilter = false"></v-date-picker>
                        </v-menu>
                        <v-card-actions class="btns-float">
                            <v-btn color="grey" @click="clearFilter" small>Limpiar</v-btn>
                            <v-btn color="accent" dark small @click="loadData">Filtrar</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>
            </v-card>
        </v-container>

        <!--Buttons-->
        <v-container class="pb-3 ml-1 mb-3">
            <v-btn color="accent" small dark @click="add" v-if="$auth.check('ADM')">Agregar Instalación</v-btn>
            <v-btn small color="accent" dark class="ml-5" @click="exportPDF">
                PDF <v-icon dark right>mdi-adobe-acrobat</v-icon>
            </v-btn>
            <v-btn small color="accent" class="ml-5" dark @click="exportExcel">
                Excel <v-icon dark right>mdi-file-excel-outline</v-icon>
            </v-btn>
        </v-container>

        <!--------------------------------------NewForm---------------------------------------------->
        <template>
            <v-row justify="center">
                <v-dialog persistent v-model="nuevoForm" max-width="850">

                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Agregar Instalación</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <!--style="font-weight: 900"-->
                    <v-tabs v-model="tab" grow background-color="#90CAF9">
                        <v-tabs-slider color="blue"></v-tabs-slider>
                        <v-tab href="#instalacion">Instalación</v-tab>
                        <v-tab href="#mapa">Mapa</v-tab>
                        <v-tab href="#supervisor">Supervisores</v-tab>
                        <v-tab href="#tipos">Tipos de elementos y variables</v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item :key="1" value="instalacion">
                            <v-card class="mx-auto">
                                <v-form ref="formularioNuevo" class="slim">
                                    <v-container class="d-flex pt-6 flex-row flex-wrap">
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCodigo" label="Código" outlined dense :rules="reglaCodigoInstalacion"></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTNombre" label="Nombre" outlined dense :rules="reglaNombreInstalacion"></v-text-field>

                                        <v-autocomplete class="pr-2 mx-240 " v-model="instalation.fkNEmpresa" :items="companies" item-text="fldTNombre" item-value="idNEmpresa" label="Empresa" clearable outlined dense :rules="reglaEmpresa"></v-autocomplete>

                                        <!--Tipo Relacion Empresa Instalacion-->
                                        <v-autocomplete class="pr-2 mx-240" v-model="instalation.fkNTipoRelacionEmpresaInstalacion" :items="tiposRelacionesInstalacionEmpresa" item-text="fldTNombre" item-value="idNTipoRelacionEmpresaInstalacion" :rules="reglaTipoRelacionInstalacionEmpresa" label="Tipo Relación con Empresa" clearable outlined dense></v-autocomplete>

                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNMunicipio" :items="municipalities" item-text="fldTMunicipioEndonimo" item-value="idMunicipio" label="Municipio" clearable outlined dense></v-autocomplete>

                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTDireccion" label="Dirección" outlined dense></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCP" label="Código Postal" outlined dense></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTTelefono" label="Telefono" outlined dense></v-text-field>

                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNGestor" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Gestor de mantenimiento" outlined clearable dense></v-autocomplete>
                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNJefeZona" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Jefe de zona" outlined clearable dense></v-autocomplete>

                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNTecnico" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Técnico" outlined clearable dense></v-autocomplete>
                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNEjecutivo" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Ejecutivo" outlined clearable dense></v-autocomplete>

                                        <v-menu v-model="menuFechaApertura" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDApertura" label="Fecha de apertura" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDApertura" locale="es-es" @input="menuFechaApertura = false"></v-date-picker>
                                        </v-menu>

                                        <v-menu v-model="menuFechaCierre" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDCierre" label="Fecha de cierre" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDCierre" locale="es-es" @input="menuFechaCierre = false"></v-date-picker>
                                        </v-menu>

                                        <v-menu v-model="menuFechaAlta" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDAlta" label="Fecha de alta" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDAlta" locale="es-es" @input="menuFechaAlta = false"></v-date-picker>
                                        </v-menu>
                                        <v-menu v-model="menuFechaBaja" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDBaja" label="Fecha de baja" prepend-icon="" clearable outlined dense readonly v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDBaja" locale="es-es" @input="menuFechaBaja = false"></v-date-picker>
                                        </v-menu>
                                        <v-autocomplete class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" :items="iconList" item-text="fldTNombre" item-value="idNIcono" label="Icono" clearable outlined dense></v-autocomplete>
                                        <!--<image-selector class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" dense></image-selector>-->
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLongitud" label="Longitud" outlined dense @change="saveMarker"></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLatitud" label="Latitud" outlined dense @change="saveMarker"></v-text-field>
                                        <v-card-actions class="btns-float px-6 pb-6">
                                            <v-btn text small @click="nuevoForm = false">
                                                cancelar
                                            </v-btn>
                                            <v-btn color="blue" dark small @click="saveData">
                                                Guardar cambios
                                            </v-btn>
                                        </v-card-actions>

                                    </v-container>
                                </v-form>

                            </v-card>
                        </v-tab-item>
                        <v-tab-item :key="2" value="mapa">
                            <v-card class="mx-auto" style="height:60vh;" outlined>
                                <!--v-if="instalation.fldNLongitud && instalation.fldNLatitud"-->
                                <GmapMap style="width: 100%; height: 100%;" :zoom="newZoom" :center="newCenter" ref="map" :options="mapOptions">
                                    <GmapMarker :key="index"
                                                v-for="(m, index) in newMarkers"
                                                :position="m.position" /> <!--@click="newCenter=m.position"-->
                                </GmapMap>
                            </v-card>
                            <!--<v-card style="height:60vh;" v-if="instalation.fldNLongitud===null || instalation.fldNLatitud===null">
                                <h4 class="text-center mt-4">Deberá ingresar latitud y longitud en los datos de la instalación</h4>
                            </v-card>-->
                            <v-card-actions class="justify-space-between w-100 pb-6">

                                <div class="justify-right">
                                    <v-btn class="ma-2" small color="blue lighten-5" @click="nuevoForm = false">
                                        Cerrar
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-tab-item>
                        <v-tab-item :key="3" value="supervisor">
                            <v-card class="mx-auto" style="height:60vh;">
                                <v-container class="pb-3 ml-1 mb-3" v-if="supervisor.idNSupervisor===null && !nuevoFormSupervisor">
                                    <v-btn color="accent" small dark @click="addSupervisor">Agregar Supervisor</v-btn>
                                </v-container>
                                <v-card v-if="nuevoFormSupervisor" class="mx-auto">
                                    <v-toolbar color="blue" dark>
                                        <v-toolbar-title>{{supervisor.idNSupervisor ? 'Editar' : 'Nuevo'}} Supervisor</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-form ref="formularioNuevoSupervisor" class="slim">
                                        <v-container class="d-flex pt-6 flex-row flex-wrap">
                                            <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTNombre" label="Nombre" :rules="nombreRules" outlined dense></v-text-field>
                                            <v-autocomplete class="pr-3 mx-240" v-model="supervisor.fkNVersion" :items="versions" item-text="fldTNombre" item-value="idNVersionSupervisor" label="Version" outlined :rules="versionRules" clearable dense></v-autocomplete>
                                            <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTVariableReceptoraNX" label="Variable Receptora NX" :rules="variableReceptoraRules" outlined dense></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTIp" label="IP" outlined dense></v-text-field>
                                            <!--<v-text-field class="mx-240" v-model="supervisor.fldDUltimaTransmisionRecibida" label="Ultima Transmision Recibida" :rules="ultimaTransmisionRules" outlined dense></v-text-field>-->
                                            <v-card-actions class="btns-float px-6 pb-6">
                                                <v-btn text small @click="nuevoFormSupervisor = false; supervisor.idNSupervisor=null">
                                                    cancelar
                                                </v-btn>
                                                <v-btn color="blue" dark small @click="saveDataSupervisor">
                                                    Guardar cambios
                                                </v-btn>
                                            </v-card-actions>
                                        </v-container>
                                    </v-form>
                                </v-card>
                                <v-card v-if="!nuevoFormSupervisor">
                                    <br />
                                    <v-data-table dense :headers="headers_supervisores" :items="supervisors" :items-per-page="5" :footer-props="{'items-per-page-options': [5, 10, 20, 50]}" class="elevation-1 gt slim">
                                        <template v-slot:item.ico1="{ item }">
                                            <v-chip :color="item.ico1" dark label></v-chip>
                                        </template>
                                        <template v-slot:item.fkNInstalacion="{ item }">
                                            {{getInstaDescription(item.fkNInstalacion)}}
                                        </template>
                                        <template v-slot:item.fkNVersion="{ item }">
                                            {{getVerDescription(item.fkNVersion)}}
                                        </template>
                                        <template v-slot:item.fldDUltimaTransmisionRecibida="{item}">
                                            {{getUltimaTransmisionRecibida(item.fldDUltimaTransmisionRecibida)}}
                                        </template>

                                        <template v-slot:item.action="{ item }">
                                            <v-icon color="green" @click="editItemSupervisor(item)" class="ml-3">
                                                mdi-pencil
                                            </v-icon>
                                        </template>


                                    </v-data-table>
                                </v-card>
                                <v-card-actions class="justify-space-between w-100 pb-6">

                                    <div class="justify-right">
                                        <v-btn class="ma-2" small color="blue lighten-5" @click="nuevoForm = false">
                                            Cerrar
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item :key="4" value="tipos">
                            <v-card style="height:60vh;">
                                <v-container class="d-flex pt-2 flex-wrap justify-center">
                                    <v-autocomplete class="pl-3 pr-3 mx-240" v-model="idNSupervisor"
                                                    :items="supervisors" item-text="fldTNombre"
                                                    item-value="idNSupervisor" label="Supervisor"
                                                    outlined clearable dense @change="loadTiposElementos(); loadVariables();"></v-autocomplete>
                                </v-container>
                                <v-container class="d-flex pt-6 flex-row flex-wrap justify-center ml-24" style="margin-top: -16px !important">
                                    <!--treeview-->
                                    <v-row>
                                        <!--<v-col v-if="!tiposElementosItems.length" class="element-tree-view">
                                        </v-col>-->
                                        <v-col class="element-tree-view">
                                            <template v-if="!tiposElementosItems.length" style="font-weight: 300">
                                                Por favor seleccione el Supervisor.
                                            </template>
                                            <template v-else>
                                                <v-treeview v-model="selectionVariables"
                                                            :items="tiposElementosItems"
                                                            :selection-type="selectionType"
                                                            selectable
                                                            return-object
                                                            dense
                                                            open-all>
                                                    <template v-slot:label="{ item }">
                                                        <span class="item-font">
                                                            {{ item.name }}
                                                        </span>
                                                    </template>
                                                </v-treeview>
                                            </template>
                                        </v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col class="variable-tree-view" cols="6">
                                            <template v-if="!selectionVariables.length" class="item-font" style="font-weight: 300">
                                                No hay variables seleccionadas.
                                            </template>
                                            <template v-else>
                                                <v-treeview v-model="selectionVariables"
                                                            :items="selectionVariables"
                                                            :selection-type="selectionType"
                                                            selectable
                                                            return-object
                                                            dense
                                                            open-all>
                                                    <template v-slot:label="{ item }">
                                                        <v-btn dark color="blue" small
                                                               style="width: 18px !important; min-width: 18px !important; max-width: 18px !important; height: 18px !important; max-height: 18px !important; padding: 0px !important;">
                                                            <v-icon small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                        <span class="item-font">
                                                            {{ item.name }}
                                                        </span>
                                                    </template>
                                                </v-treeview>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                            <v-card-actions class="justify-space-between w-100 pb-6">

                                <div class="justify-right">
                                    <v-btn class="ma-2" small color="blue lighten-5" @click="nuevoForm = false">
                                        Cerrar
                                    </v-btn>
                                </div>
                                <div class="justify-left">
                                    <v-btn class="ma-2" dark small color="blue" @click="saveDataVariables">
                                        Guardar cambios
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-tab-item>

                    </v-tabs-items>

                </v-dialog>
            </v-row>
        </template>

        <!--------------------------------------EditForm---------------------------------------------->
        <template>
            <v-row justify="center">
                <v-dialog persistent v-model="editForm" max-width="850">

                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Editar Instalación</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-tabs v-model="tab" grow background-color="#90CAF9">
                        <v-tabs-slider color="blue"></v-tabs-slider>
                        <v-tab href="#instalacion">Instalación</v-tab>
                        <v-tab href="#mapa">Mapa</v-tab>
                        <v-tab href="#supervisor">Supervisores</v-tab>
                        <v-tab href="#tipos">Tipos de elementos y variables</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item :key="1" value="instalacion">
                            <v-card class="mx-auto">
                                <v-form ref="formularioEdicion" class="slim">
                                    <v-container class="d-flex pt-6 flex-row flex-wrap justify-center">
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCodigo" label="Código de instalación" outlined dense :rules="reglaCodigoInstalacion" :disabled="puedeCambiar == false"></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTNombre" label="Nombre de la instalación" outlined dense :rules="reglaNombreInstalacion" :disabled="puedeCambiar == false"></v-text-field>

                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNEmpresa" :items="companies" item-text="fldTNombre" item-value="idNEmpresa" label="Empresa" clearable outlined dense :rules="reglaEmpresa" :disabled="puedeCambiar == false" @change="actualizarRelacionEmpresaInstalacion"></v-autocomplete>
                                        <!--Tipo Relacion Empresa Instalacion-->
                                        <v-autocomplete class="pr-2 mx-240" v-model="instalation.fkNTipoRelacionEmpresaInstalacion" :items="tiposRelacionesInstalacionEmpresa" item-text="fldTNombre" item-value="idNTipoRelacionEmpresaInstalacion" label="Tipo Relación con Empresa" :rules="reglaTipoRelacionInstalacionEmpresa" :disabled="puedeCambiar == false" clearable outlined dense></v-autocomplete>

                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNMunicipio" :items="municipalities" item-text="fldTMunicipioEndonimo" item-value="idMunicipio" label="Municipio" clearable outlined dense :disabled="puedeCambiar == false"></v-autocomplete>

                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTDireccion" label="Dirección" outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTCP" label="Código Postal" outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldTTelefono" label="Telefono" outlined dense :disabled="puedeCambiar == false"></v-text-field>

                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNGestor" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Gestor de mantenimiento" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>
                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNJefeZona" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Jefe de zona" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>

                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNTecnico" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Técnico" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>
                                        <v-autocomplete class="pr-3 mx-240" v-model="instalation.fkNEjecutivo" :items="contacts" item-text="fldTNombre" item-value="idNContacto" label="Ejecutivo" outlined clearable dense :disabled="puedeCambiar == false"></v-autocomplete>

                                        <v-menu v-model="menuFechaAperturaEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDApertura" label="Fecha de apertura" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDApertura" locale="es-es" @input="menuFechaAperturaEdit = false"></v-date-picker>
                                        </v-menu>

                                        <v-menu v-model="menuFechaCierreEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDCierre" label="Fecha de cierre" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDCierre" locale="es-es" @input="menuFechaCierreEdit = false"></v-date-picker>
                                        </v-menu>

                                        <v-menu v-model="menuFechaAltaEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDAlta" label="Fecha de alta" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDAlta" locale="es-es" @input="menuFechaAltaEdit = false"></v-date-picker>
                                        </v-menu>
                                        <v-menu v-model="menuFechaBajaEdit" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field class="pr-3 mx-240" v-model="instalation.fldDBaja" label="Fecha de baja" prepend-icon="" clearable outlined dense :disabled="puedeCambiar == false" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="instalation.fldDBaja" locale="es-es" @input="menuFechaBajaEdit = false"></v-date-picker>
                                        </v-menu>
                                        <v-autocomplete class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" :items="iconList" item-text="fldTNombre" item-value="idNIcono" label="Icono" clearable outlined dense></v-autocomplete>
                                        <!--<image-selector class="pr-3 mx-0 pa-0 mx-240" v-model="instalation.fkNIcono" dense :disabled="puedeCambiar == false" outlined label="Icono"></image-selector>-->
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLongitud" label="Longitud" outlined dense :disabled="puedeCambiar == false"></v-text-field>
                                        <v-text-field class="pr-3 mx-240" v-model="instalation.fldNLatitud" label="Latitud" outlined dense :disabled="puedeCambiar == false"></v-text-field>

                                        <v-card-actions class="justify-space-between w-100 pb-6">
                                            <div class="justify-left">
                                                <v-btn class="ma-2" dark small color="red" @click="deleteItem" v-if="$auth.check('ADM')">
                                                    <v-icon left>mdi-delete</v-icon> Borrar registro
                                                </v-btn>
                                            </div>
                                            <div class="justify-right">
                                                <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                                    Cancelar
                                                </v-btn>
                                                <template v-if="activateEdit">
                                                    <v-btn v-if="!puedeCambiar" class="ma-2" dark small color="success" @click="puedeCambiar = true">
                                                        <v-icon left>mdi-pencil</v-icon> Editar
                                                    </v-btn>
                                                    <v-btn v-else class="ma-2" dark small color="success" @click="saveData">
                                                        <v-icon left>mdi-pencil</v-icon> Guardar
                                                    </v-btn>
                                                </template>
                                            </div>
                                        </v-card-actions>
                                    </v-container>
                                </v-form>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item :key="2" value="mapa">
                            <v-card class="mx-auto" style="height:60vh;" outlined v-if="instalation.fldNLongitud && instalation.fldNLatitud">
                                <GmapMap style="width: 100%; height: 100%;" :zoom="zoom" :center="center" ref="map" :options="mapOptions">
                                    <GmapMarker :key="index"
                                                v-for="(m, index) in markers"
                                                :position="m.position"
                                                @click="center=m.position" />
                                </GmapMap>
                            </v-card>
                            <v-card style="height:60vh;" v-if="instalation.fldNLongitud===null || instalation.fldNLatitud===null">
                                <h4>Deberá ingresar latitud y longitud en los datos de la instalación</h4>
                            </v-card>
                            <v-card-actions class="justify-space-between w-100 pb-6">

                                <div class="justify-right">
                                    <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                        Cerrar
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-tab-item>
                        <v-tab-item :key="3" value="supervisor">
                            <v-card class="mx-auto" style="height:60vh;">
                                <v-container class="pb-3 ml-1 mb-3" v-if="supervisor.idNSupervisor===null && !nuevoFormSupervisor">
                                    <v-btn color="accent" small dark @click="addSupervisor">Agregar Supervisor</v-btn>
                                </v-container>
                                <v-card v-if="nuevoFormSupervisor" class="mx-auto">
                                    <v-toolbar color="blue" dark>
                                        <v-toolbar-title>{{supervisor.idNSupervisor ? 'Editar' : 'Nuevo'}} Supervisor</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-form ref="formularioNuevoSupervisor" class="slim">
                                        <v-container class="d-flex pt-6 flex-row flex-wrap">
                                            <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTNombre" label="Nombre" :rules="nombreRules" outlined dense></v-text-field>
                                            <v-autocomplete class="pr-3 mx-240" v-model="supervisor.fkNVersion" :items="versions" item-text="fldTNombre" item-value="idNVersionSupervisor" label="Version" outlined :rules="versionRules" clearable dense></v-autocomplete>
                                            <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTVariableReceptoraNX" label="Variable Receptora NX" :rules="variableReceptoraRules" outlined dense></v-text-field>
                                            <v-text-field class="pr-3 mx-240" v-model="supervisor.fldTIp" label="IP" outlined dense></v-text-field>
                                            <!--<v-text-field class="mx-240" v-model="supervisor.fldDUltimaTransmisionRecibida" label="Ultima Transmision Recibida" :rules="ultimaTransmisionRules" outlined dense></v-text-field>-->
                                            <v-card-actions class="btns-float px-6 pb-6">
                                                <v-btn text small @click="nuevoFormSupervisor = false; supervisor.idNSupervisor=null">
                                                    cancelar
                                                </v-btn>
                                                <v-btn color="blue" dark small @click="saveDataSupervisor">
                                                    Guardar cambios
                                                </v-btn>
                                            </v-card-actions>
                                        </v-container>
                                    </v-form>
                                </v-card>
                                <v-card v-if="!nuevoFormSupervisor">
                                    <br />
                                    <v-data-table dense :headers="headers_supervisores" :items="supervisors" :items-per-page="5" :footer-props="{'items-per-page-options': [5, 10, 20, 50]}" class="elevation-1 gt slim">
                                        <template v-slot:item.ico1="{ item }">
                                            <v-chip :color="item.ico1" dark label></v-chip>
                                        </template>
                                        <template v-slot:item.fkNInstalacion="{ item }">
                                            {{getInstaDescription(item.fkNInstalacion)}}
                                        </template>
                                        <template v-slot:item.fkNVersion="{ item }">
                                            {{getVerDescription(item.fkNVersion)}}
                                        </template>
                                        <template v-slot:item.fldDUltimaTransmisionRecibida="{item}">
                                            {{getUltimaTransmisionRecibida(item.fldDUltimaTransmisionRecibida)}}
                                        </template>

                                        <template v-slot:item.action="{ item }">
                                            <v-icon color="green" @click="editItemSupervisor(item)" class="ml-3">
                                                mdi-pencil
                                            </v-icon>
                                        </template>


                                    </v-data-table>
                                </v-card>
                                <v-card-actions class="justify-space-between w-100 pb-6">

                                    <div class="justify-right">
                                        <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                            Cerrar
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item :key="4" value="tipos">
                            <v-card style="height:60vh;">
                                <v-container class="d-flex pt-2 flex-wrap justify-center">
                                    <v-autocomplete class="pl-3 pr-3 mx-240" v-model="idNSupervisor"
                                                    :items="supervisors" item-text="fldTNombre"
                                                    item-value="idNSupervisor" label="Supervisor"
                                                    outlined clearable dense @change="loadTiposElementos(); loadVariables();"></v-autocomplete>
                                </v-container>
                                <v-container class="d-flex pt-6 flex-row flex-wrap justify-center ml-24" style="margin-top: -16px !important">
                                    <!--treeview-->
                                    <v-row>
                                        <v-col class="element-tree-view">
                                            <template v-if="!tiposElementosItems.length" style="font-weight: 300">
                                                Por favor seleccione el Supervisor.
                                            </template>
                                            <template v-else>
                                                <!--v-model="selectionVariables"-->
                                                <v-treeview :items="tiposElementosItems"
                                                            :selection-type="selectionType"
                                                            selectable
                                                            return-object
                                                            dense
                                                            open-all>
                                                    <template v-slot:label="{ item }">
                                                        <span class="item-font">
                                                            {{ item.name }}
                                                        </span>
                                                    </template>
                                                </v-treeview>
                                            </template>
                                        </v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col class="variable-tree-view" cols="6">
                                            <template v-if="!selectionVariables.length" class="item-font" style="font-weight: 300">
                                                No hay variables seleccionadas.
                                            </template>
                                            <template v-else>
                                                <v-treeview v-model="selectionVariables"
                                                            :items="selectionVariables"
                                                            :selection-type="selectionType"
                                                            selectable
                                                            return-object
                                                            dense
                                                            open-all>
                                                    <template v-slot:label="{ item }">
                                                        <v-btn dark color="blue" small
                                                               style="width: 18px !important; min-width: 18px !important; max-width: 18px !important; height: 18px !important; max-height: 18px !important; padding: 0px !important;">
                                                            <v-icon small>mdi-pencil</v-icon>
                                                        </v-btn>
                                                        <span class="item-font">
                                                            {{ item.name }}
                                                        </span>
                                                    </template>
                                                </v-treeview>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                            <v-card-actions class="justify-space-between w-100 pb-6">

                                <div class="justify-right">
                                    <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                        Cerrar
                                    </v-btn>
                                </div>
                                <div class="justify-left">
                                    <v-btn class="ma-2" dark small color="blue" @click="saveDataVariables">
                                        Guardar cambios
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-tab-item>
                    </v-tabs-items>
                </v-dialog>
            </v-row>
        </template>

        <!--Table-->
        <v-container fluid class="pt-0">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <template>
                            <v-data-table dense
                                          :headers="headers"
                                          :items="instalations"
                                          item-key="cod"
                                          :footer-props="{'items-per-page-options': [5, 10, 20, 50]}"
                                          class="elevation-1 gt slim">
                                <template v-slot:item.ico1="{ item }">
                                    <v-chip :color="item.ico1" dark label></v-chip>
                                </template>

                                <template v-slot:item.fkNEjecutivo="{item}">
                                    {{getContactName(item.fkNEjecutivo)}}
                                </template>
                                <template v-slot:item.fkNGestor="{item}">
                                    {{getContactName(item.fkNGestor)}}
                                </template>
                                <template v-slot:item.fkNTecnico="{item}">
                                    {{getContactName(item.fkNTecnico)}}
                                </template>
                                <template v-slot:item.fkNJefeZona="{item}">
                                    {{getContactName(item.fkNJefeZona)}}
                                </template>
                                <template v-slot:item.fldDUltimaTransmisionRecibida="{item}">
                                    {{getUltimaTransmisionRecibida(item.fldDUltimaTransmisionRecibida)}}
                                </template>

                                <template v-slot:item.ico2="{ item }">
                                    <v-btn text icon @click.stop="openDetail(item)">
                                        <v-icon color="blue">mdi-file-document-outline</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:item.fkNIcono="{item}">
                                    <img class="mx-1" v-if="item.fkNIcono != null" :src="item.fkNIcono"
                                         aspect-ratio="1"
                                         width="13"
                                         height="13"
                                         contain>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-icon color="green" @click="openWizard(item)">
                                        mdi-pencil
                                    </v-icon>
                                </template>
                                <template v-slot:item.delete="{ item }">
                                    <v-icon color="red" @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <confirm ref="confirmDialog">
        </confirm>
    </div>
</template>

<script>
    import {
        Component,
        Prop,
        Vue
    } from "vue-property-decorator";
    import InstalationCompanyRelationshipClassService from "../services/InstalationCompanyRelationshipClassService";
    import InstalationCompanyRelationshipService from "../services/InstalationCompanyRelationshipService";
    import InstalationService from '@/services/InstalationsService';
    import MunicipalityService from '@/services/MunicipalityService';
    import ContactService from '@/services/ContactService';
    import CompanyService from '@/services/CompanyService';
    import ProvinceService from '@/services/ProvinceService';
    import DashboardService from '@/services/DashboardService';
    import InstalationModel from '@/models/InstalationModel';
    import InstalationCompanyRelationshipModel from '@/models/InstalationCompanyRelationshipModel';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import Confirm from '@/components/ConfirmDelete';
    import ImageSelector from '@/components/ImageSelector';
    import router from '../router';
    import IconModel from '../models/IconModel';
    import IconService from '../services/IconService';
    import moment from "moment";
    import SupervisorService from "../services/SupervisorService";
    import SupervisorModel from "../models/SupervisorModel";
    import VersionService from "../services/VersionService";
    import GmapCluster from 'vue2-google-maps/src/components/cluster'
    import ElementTypeService from "../services/ElementTypeService";
    import VariableService from "../services/VariableService";


    @Component({
        components: {
            Confirm,
            ImageSelector,
            GmapCluster
        }
    })
    export default class Instalaciones extends Vue {

        async loadData() {
            try {

                if (this.$data.filter.fkNMunicipio < 1) {
                    this.$data.filter.fkNMunicipio = null;
                }
                if (this.$data.filter.fkNGestor < 1) {
                    this.$data.filter.fkNGestor = null;
                }
                if (this.$data.filter.fkNJefeZona < 1) {
                    this.$data.filter.fkNJefeZona = null;
                }
                if (this.$data.filter.fkNEmpresa < 1) {
                    this.$data.filter.fkNEmpresa = null;
                }
                if (this.$data.filter.fkNTecnico < 1) {
                    this.$data.filter.fkNTecnico = null;
                }
                if (this.$data.filter.fkNEjecutivo < 1) {
                    this.$data.filter.fkNEjecutivo = null;
                }

                var resultMunic = await new MunicipalityService().list({});
                if (resultMunic.success) {
                    this.$data.municipalities = resultMunic.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultMunic.Message);
                }

                var result = await new ContactService().list({});
                if (result.success) {
                    this.$data.contacts = result.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + result.Message);
                }

                var resultComp = await new CompanyService().list({});
                if (resultComp.success) {
                    this.$data.companies = resultComp.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultComp.Message);
                }

                var resultProv = await new ProvinceService().list({});
                if (resultProv.success) {
                    this.$data.provinces = resultProv.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultProv.Message);
                }

                // En el caso de que sea llamado desde el Dashboard panel y titulo
                if (this.$route.query.panel != null) {
                    // TODO hacer qeu tome el titulo
                    // this.$route.meta.title = this.$route.query.titulo;
                    const instalationsLists = await new DashboardService().GetDashboardInstalationListByPanel(this.$route.query.panel);
                    if (instalationsLists.length > 0) {
                        this.filter.incluidaEn = instalationsLists[0].tiendas;
                    }
                }

                var inst;
                var resultInst = await new InstalationService().list(this.filter);
                if (resultInst.success) {
                    inst = resultInst.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultInst.Message);
                    return;
                }

                //Set LocalStorage: IconsAll
                await new IconService().setIconsAll(new IconModel());

                let dataInstAux = [];
                for (let i = 0; i < inst.length; i++) {

                    let e = inst[i];

                    if (e.fkNIcono != undefined && e.fkNIcono != null) {
                        e.fkNIcono = new IconService().getIconFromStorage(e.fkNIcono);
                    }
                    dataInstAux.push(e);
                }

                var resultIcons = await new IconService().list({});
                if (resultIcons.success) {
                    this.$data.iconList = resultIcons.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultIcons.Message);
                }


                this.$data.instalations = inst;

                var res = await new InstalationCompanyRelationshipClassService().list(this.filter);
                if (res.success) {
                    this.$data.tiposRelacionesInstalacionEmpresa = res.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + res.Message);
                }
                this.loadVersions();

            } catch (e) {
                console.log("Error en Carga de Tabla")
                console.log(e);
            }
        }
        async saveDataVariables() {
            console.log(JSON.stringify(this.$data.selectionVariables));
        }
        addSupervisor() {
            this.$data.supervisor = new SupervisorModel();
            this.$data.supervisor.fkNInstalacion = this.$data.instalation.idNInstalacion;
            this.$data.nuevoFormSupervisor = true;
        }
        editItemSupervisor(item) {
            this.$data.supervisor = JSON.parse(JSON.stringify(item));
            this.$data.nuevoFormSupervisor = true;
        }
        async saveDataSupervisor() {
            try {
                if (this.$refs.formularioNuevoSupervisor != null) {
                    if (!this.$refs.formularioNuevoSupervisor.validate()) {
                        return;
                    }
                }

                /*  if (this.$refs.formularioEdicion != null) {
                      if (!this.$refs.formularioEdicion.validate()) {
                          return;
                      }
                  }*/

                var uService = new SupervisorService();
                var data = null;
                if (this.$data.supervisor.idNSupervisor) {
                    data = await uService.update(this.$data.supervisor);
                } else {
                    data = await uService.insert(this.$data.supervisor);
                }

                if (data.success) {
                    this.nuevoFormSupervisor = false;
                    this.$data.supervisor.idNSupervisor = null
                    this.loadSupervisor();
                    this.showSuccess('El registro fue guardado correctamente');
                } else {
                    this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                }
            } catch (e) {
                console.log(e);
            }
        }
        async loadSupervisor() {
            let filterSupervisor = new SupervisorModel();
            filterSupervisor.fkNInstalacion = this.$data.instalation.idNInstalacion;
            var resSup = await new SupervisorService().list(filterSupervisor);
            if (resSup.success) {
                this.$data.supervisors = resSup.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resSup.Message);
            }

        }
        async loadVersions() {
            var resultV = await new VersionService().list({});
            if (resultV.success) {
                this.$data.versions = resultV.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resultV.Message);
            }
        }
        async loadTiposElementos() {
            var idNSupervisor = this.$data.idNSupervisor;
            if (idNSupervisor && !isNaN(idNSupervisor)) {
                //console.log(idNSupervisor);
                var resultTE = await new ElementTypeService().listBySupervisor(idNSupervisor);
                if (resultTE.success) {
                    //console.log(JSON.stringify(resultTE.data));
                    this.$data.tiposElementosItems = resultTE.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultTE.Message);
                }
            }
            else {
                this.$data.tiposElementosItems = [];
            }
        }
        async loadVariables() {
            var idNSupervisor = this.$data.idNSupervisor;
            if (idNSupervisor && !isNaN(idNSupervisor)) {
                console.log(idNSupervisor);
                var resultVa = await new VariableService().listBySupervisor(idNSupervisor);
                if (resultVa.success) {
                    //console.log(JSON.stringify(resultVa.data));
                    this.$data.selectionVariables = resultVa.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultVa.Message);
                }
            }
            else {
                this.$data.selectionVariables = [];
            }
        }

        clearFilter() {
            this.$data.filter = new InstalationModel();
            this.loadData();
        }

        add() {
           /* this.$data.e1 = 1;
            this.$data.instalation = new InstalationModel();
            this.$data.supervisor = new SupervisorModel();
            this.$data.nuevoForm = true;*/
            this.redirectToWizard(null);
        }

        async openDetail(item) {
            this.redirectToGlobal(item.idNInstalacion);
        }
        async openWizard(item) {
            this.redirectToWizard(item.idNInstalacion);
        }

        redirectToGlobal(idNInstalacion) {
            this.dialogDetail = false;
            let routeData = this.$router.resolve({
                name: 'InstalacionesGlobal',
                params: {
                    id: idNInstalacion
                }
            });
            window.open(routeData.href, '_blank');
        }
        redirectToWizard(idNInstalacion) {
            
            let routeData = this.$router.resolve({
                name: 'InstalacionesWizard',
                params: {
                    id: idNInstalacion
                }
            });
            window.open(routeData.href, '_blank');
        }

        async saveMarker() {
            console.log(this.$data.instalation.fldNLatitud + " - " + this.$data.instalation.fldNLongitud);
            if (!isNaN(this.$data.instalation.fldNLatitud) && !isNaN(this.$data.instalation.fldNLongitud)) {
                const newMarker = {
                    lat: this.$data.instalation.fldNLatitud,
                    lng: this.$data.instalation.fldNLongitud,
                };
                console.log(JSON.stringify(newMarker));
                this.newMarkers = [];
                this.newMarkers.push({ position: newMarker });
                this.newCenter = newMarker;
                console.log(JSON.stringify(this.newMarkers));
                console.log(JSON.stringify(this.newCenter));
            }
        }

        async saveData() {
            try {
                if (this.$refs.formularioNuevo != null) {
                    if (!this.$refs.formularioNuevo.validate()) {
                        return;
                    }
                }

                if (this.$refs.formularioEdicion != null) {
                    if (!this.$refs.formularioEdicion.validate()) {
                        return;
                    }
                }

                var uService = new InstalationService(this.filter);
                var data = null;

                if (this.$data.instalation.idNInstalacion) {

                    // Este update tambien incluye la actualizacion de RelacionEmpresaInstalacion
                    data = await uService.update(this.$data.instalation);

                } else {

                    // Este insert tambien incluye la insercion de RelacionEmpresaInstalacion
                    /*let wizard = {
                        instalacion: this.$data.instalation,
                        supervisor: this.$data.supervisor
                    }
                    data = await uService.insert(wizard);*/
                    data = await uService.insert(this.$data.instalation);

                }

                const newMarker = {
                    lat: this.$data.instalation.fldNLatitud,
                    lng: this.$data.instalation.fldNLongitud,
                };
                this.newMarkers.push({ position: newMarker });
                this.newCenter = newMarker;

                if (data.success) {
                    this.nuevoForm = false;
                    this.closeDialog();
                    this.loadData();
                    this.showSuccess('El registro fue guardado correctamente');
                } else {
                    this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                }
            } catch (e) {
                console.log(e);
            }
        }



        async actualizarRelacionEmpresaInstalacion() {
            var relacion = await new InstalationCompanyRelationshipService().getByInstalationAndCompany(this.instalation.idNInstalacion, this.instalation.fkNEmpresa);
            if (relacion.data[0] != null) {
                this.instalation.fkNTipoRelacionEmpresaInstalacion = relacion.data[0].fkNTipoRelacionEmpresaInstalacion;
                this.instalationAux.fkNTipoRelacionEmpresaInstalacion = relacion.data[0].fkNTipoRelacionEmpresaInstalacion;
            } else {
                this.instalation.fkNTipoRelacionEmpresaInstalacion = null;
                this.instalationAux.fkNTipoRelacionEmpresaInstalacion = null;
            }
        }
        getInstaDescription(id) {
            let desc = this.$data.instalations.find(function (e) {
                return e.idNInstalacion == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        }
        getVerDescription(id) {
            let desc = this.$data.versions.find(function (e) {
                return e.idNVersionSupervisor == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        }
        getUltimaTransmisionRecibida(date) {
            if (date != null) {
                return moment(date).format('DD/MM/YYYY HH:mm');
            } else {
                return "";
            }
        }

        getTypeDescription(id) {
            let desc = this.userTypes.find(function (e) {
                return e.idNTipoUsuario == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        }

        getContactName(id) {
            if (this.$data.contacts != null) {
                let name = this.$data.contacts.find(x => x.idNContacto == id);
                if (name)
                    return name.fldTNombre;
                return id;
            } else {
                return id;
            }
        }
        chkBotonCancelar() {
            // Estoy editando y presiono cancelar
            if (this.$data.puedeCambiar == true && this.$data.editForm == true) {
                this.$data.instalation = JSON.parse(JSON.stringify(this.$data.instalationAux));
                this.$data.puedeCambiar = false;
            } else {
                this.closeDialog();
            }
        }

        closeDialog() {
            this.editForm = false;
            this.puedeCambiar = false;
            this.alert = false;
            this.$data.instalation = new InstalationModel();
            this.$data.instalationAux = new InstalationModel();
        }

        async editItem(item) {

            if (item.fldDApertura != null) {
                var apertura = new Date(item.fldDApertura);
                item.fldDApertura = apertura.toISOString().substr(0, 10);
            }

            if (item.fldDCierre != null) {
                var cierre = new Date(item.fldDCierre);
                item.fldDCierre = cierre.toISOString().substr(0, 10);
            }

            if (item.fldDAlta != null) {
                var alta = new Date(item.fldDAlta);
                item.fldDAlta = alta.toISOString().substr(0, 10);
            }

            if (item.fldDBaja != null) {
                var baja = new Date(item.fldDBaja);
                item.fldDBaja = baja.toISOString().substr(0, 10);
            }

            this.$data.modelEmpty = 0;

            this.$data.instalation = JSON.parse(JSON.stringify(item));
            this.$data.instalationAux = JSON.parse(JSON.stringify(item));

            // Buscar su relacion, obtengo que tipo es y se la asign al modelo instalacion
            this.actualizarRelacionEmpresaInstalacion();
            this.$data.instalationAux = JSON.parse(JSON.stringify(item));

            //Bind Supervisores
            this.loadSupervisor();
            this.$data.editForm = true;

            //Bind Mapa
            const marker = {
                lat: this.$data.instalation.fldNLatitud,
                lng: this.$data.instalation.fldNLongitud,
            };
            this.markers.push({ position: marker });
            this.center = marker;
        }

        async deleteItem(item) {
            var ret = await this.$refs.confirmDialog.showDialog();
            if (ret == true) {
                this.$data.instalation = JSON.parse(JSON.stringify(item));
                var data = await new InstalationService().delete(this.$data.instalation);
                if (data.success) {
                    this.closeDialog();
                    this.showSuccess('El registro fue eliminado correctamente');
                    this.loadData();
                } else {
                    this.showError('Ocurrio un error borrando el registro: ' + data.error);
                }

            }
        }

        async exportExcel() {
            var data = await new InstalationService().export(this.filter);
            var fileURL = window.URL.createObjectURL(data);
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'instalaciones.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();
        }

        exportPDF() {
            var doc = new jsPDF({ orientation: 'landscape' });
            var title = 'Instalaciones';
            var columns = [
                { title: 'Código', dataKey: 'fldTCodigo' },
                { title: 'Nombre', dataKey: 'fldTNombre' },
                { title: 'Direccion', dataKey: 'fldTDireccion' },
                { title: 'TCP', dataKey: 'fldTTcp' },
                { title: 'Teléfono', dataKey: 'fldTTelefono' },
                { title: 'Fecha de Alta', dataKey: 'fldDAlta' },
                { title: 'Fecha de Baja', dataKey: 'fldDBaja' },
                { title: 'Gestor', dataKey: 'fkNGestor' },
                { title: 'Tecnico', dataKey: 'fkNTecnico' },
                { title: 'JefeZona', dataKey: 'fkNJefeZona' },
                { title: 'Ejecutivo', dataKey: 'fkNEjecutivo' },
                { title: 'Fecha de Apertura', dataKey: 'fldDApertura' },
                { title: 'Fecha de Cierre', dataKey: 'fldDCierre' },
                { title: 'Latitud', dataKey: 'fldNLatitud' },
                { title: 'Longitud', dataKey: 'fldNLongitud' },
            ];

            doc.text(title, 15, 15);
            var self = this;
            var data = JSON.parse(JSON.stringify(this.$data.instalations));
            data.forEach(function (d) {
                d.fkNGestor = self.getContactName(d.fkNGestor);
                d.fkNTecnico = self.getContactName(d.fkNTecnico);
                d.fkNJefeZona = self.getContactName(d.fkNJefeZona);
                d.fkNEjecutivo = self.getContactName(d.fkNEjecutivo);
                if (d.fldDAlta != null) {
                    var s = d.fldDAlta.split("T")[0].split("-");
                    d.fldDAlta = s[2] + "-" + s[1] + "-" + s[0];
                }
                if (d.fldDBaja != null) {
                    var b = d.fldDBaja.split("T")[0].split("-");
                    d.fldDBaja = b[2] + "-" + b[1] + "-" + b[0];
                }
                if (d.fldDApertura != null) {
                    var a = d.fldDApertura.split("T")[0].split("-");
                    d.fldDApertura = a[2] + "-" + a[1] + "-" + a[0];
                }
                if (d.fldDCierre != null) {
                    var c = d.fldDCierre.split("T")[0].split("-");
                    d.fldDCierre = c[2] + "-" + c[1] + "-" + c[0];
                }
            });
            doc.autoTable(columns, this.$data.instalations, { margin: { top: 20 }, styles: { cellPadding: 0.5, fontSize: 8 } })
            doc.save(title + '.pdf');
        }

        get activateEdit() {
            var sel = this.instalation;
            if (this.$auth.check('ADM'))
                return true;
            if (this.$auth.check('RE'))
                return true;
            if (this.$auth.check('RI') &&
                [sel.fkNGestor, sel.fkNTecnico, sel.fkNJefeZona, sel.fkNEjecutivo].indexOf(parseInt(this.$auth.user().id)) >= 0)
                return true;

            return false;
        }



        async mounted() {
            await this.loadData();
        }

        // Para el detalle Instalacion
        detalleInstalation = false;

        nuevoForm = false;
        nuevoFormSupervisor = false;
        tab = "instalacion";
        editForm = false;
        puedeCambiar = false;
        formularioNuevo = true;
        formularioEdicion = true;
        alert = false;
        markerData = {};

        // Listas
        instalations = [];
        municipalities = [];
        companies = [];
        contacts = [];
        provinces = [];
        tiposRelacionesInstalacionEmpresa = [];
        iconList = [];
        supervisors = []; //Supervisores
        versions = [];
        tiposElementos = [];
        idNSupervisor = null;

        //TreeView
        selectionType = 'leaf';
        tiposElementosItems = [];
        selectionVariables = [];

        //Maps
        mapOptions = {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false,
            styles: [{
                'featureType': 'poi',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            }]
        };

        newZoom = 6;
        newCenter = { lat: 40.1530955, lng: -3.2961051 };
        newMarkers = [];

        zoom = 15;
        center = { lat: 0, lng: 0 };
        markers = [];

        // Modelos
        filter = new InstalationModel();
        instalation = new InstalationModel();
        instalationAux = new InstalationModel();
        relInstEmp = new InstalationCompanyRelationshipModel();
        supervisor = new SupervisorModel();
        e1 = 1;

        on = true;

        // Selects
        menuFechaApertura = false;
        menuFechaAperturaFilter = false;
        menuFechaAperturaEdit = false;
        menuFechaCierre = false;
        menuFechaCierreFilter = false;
        menuFechaCierreEdit = false;
        menuFechaAlta = false;
        menuFechaAltaEdit = false;
        menuFechaBaja = false;
        menuFechaBajaEdit = false;

        reglaCodigoInstalacion = [
            v => !!v || 'Debe ingresar un Código',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',
        ];

        reglaMunicipio = [
            v => v && v > 0 || 'Debe seleccionar un Municipio'
        ];

        reglaEmpresa = [
            v => v && v > 0 || 'Debe seleccionar una Empresa'
        ];

        reglaNombreInstalacion = [
            v => !!v || 'Debe ingresar un Nombre',
            v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',
        ];

        reglaTipoRelacionInstalacionEmpresa = [
            v => v && v > 0 || 'Debe seleccionar un Tipo de Relación'
        ];


        //Reglas Supervisor
        versionRules = [
            v => v && v > 0 || 'Debe seleccionar una Version',
        ];
        nombreRules = [
            v => !!v || 'Debe ingresar un nombre',
        ];
        variableReceptoraRules = [
            v => !!v || 'Debe ingresar una Variable',
        ];
        ipRules = [
            v => !!v || 'Debe ingresar un IP',
        ];

        headers = [{
            text: '',
            value: 'ico1',
            sortable: false,
            width: 10
        }, {
            text: '',
            value: 'action',
            sorteable: false,
            width: 10
            },
            {
                text: '',
                value: 'delete',
                sorteable: false,
                width: 10
            },{
            text: '',
            value: 'ico2',
            sortable: false,
            width: 10
        }, {
            text: '',
            value: 'fkNIcono',
            sortable: false,
            width: 10,
        }, {
            text: 'Cod.',
            value: 'fldTCodigo',
        }, {
            text: 'Nombre',
            value: 'fldTNombre'
        }, {
            text: 'GM',
            value: 'fkNGestor'
        }, {
            text: 'TM',
            value: 'fkNTecnico'
        }, {
            text: 'JZ',
            value: 'fkNJefeZona'
        }, {
            text: 'EJ',
            value: 'fkNEjecutivo'
        }, {
            text: 'Dirección',
            value: 'fldTDireccion'
        }, {
            text: 'Elementos',
            value: 'elementos'
        }, {
            text: 'Última transmisión',
            value: 'fldDUltimaTransmisionRecibida',
            width: 150
        }];

        //Supervisores
        headers_supervisores = [{
            text: '',
            value: 'ico1',
            sortable: false,
            width: 10
        },
        {
            text: '',
            value: 'action',
            sortable: false,
            width: 15
        },
        {
            text: 'Nombre',
            value: 'fldTNombre'
        },
        {
            text: 'Instalacion',
            value: 'fkNInstalacion'
        },
        {
            text: 'Version',
            value: 'fkNVersion'
        },
        {
            text: 'Variable Receptora NX',
            value: 'fldTVariableReceptoraNX'
        },
        {
            text: 'IP',
            value: 'fldTIp'
        },
        {
            text: 'Ultima Transmision Recibida',
            value: 'fldDUltimaTransmisionRecibida'
        },
        ];

    }
</script>

<style>
    .element-tree-view {
        overflow-x: scroll !important;
        overflow-y: scroll !important;
        width: 400px;
        max-width: 400px;
        height: 480px;
        max-height: 480px;
        border: 1px solid #00000060 !important;
        padding: 4px;
    }

    .variable-tree-view {
        overflow-x: scroll !important;
        overflow-y: scroll !important;
        width: 400px;
        max-width: 400px;
        height: 480px;
        max-height: 480px;
        margin-left: 12px !important;
        margin-right: 48px !important;
        border: 1px solid #00000060 !important;
        padding: 4px;
    }

    .item-font {
        font-size: 14px;
        font-weight: 400;
    }

    selected-variable-item {
    }

    .v-treeview--dense .v-treeview-node__root {
        min-height: 24px;
        padding: 0 !important;
    }

    .v-treeview-node__checkbox {
        margin-left: 0px !important;
    }

    .ml-24 {
        margin-left: 24px !important;
    }
</style>